import React, { forwardRef } from "react";
import { inputVariants, type InputVariants } from "@/utils/variants";
import { cn } from "@/utils";

interface InputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "size">, InputVariants {
  label?: string;
  error?: string;
  helperText?: string;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ variant, size, label, error, helperText, className, ...props }, ref) => {
    const inputVariant = error ? "error" : variant;

    return (
      <div className="w-full">
        {label && <label className="block text-fs-xs font-medium text-ink-2 mb-1.5">{label}</label>}
        <input ref={ref} className={cn(inputVariants({ variant: inputVariant, size }), className)} {...props} />
        {error && <p className="mt-1 text-fs-xs text-risk-d">{error}</p>}
        {helperText && !error && <p className="mt-1 text-fs-xs text-ink-3">{helperText}</p>}
      </div>
    );
  },
);

Input.displayName = "Input";

export default Input;
